import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Stack,
  CircularProgress,
  Modal,
} from "@mui/material";
import ScrollableTable from "./ScrollableTable";
import { useUser } from "../Contexts/UserContext";
import EnhancedTable from "./EnhancedTable";
import getTodayDate from "./TodaysDate";
import Table from "./Table";
import "../styles/maxAttendanceCard.css";

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const columns = [
  { id: "Branch", label: "Branch", idx: -2 },
  { id: "SubUnit", label: "SubUnit", idx: -1 },
  { id: "Empcode", label: "EmpCode", idx: 0 },
  { id: "EmpName", label: "EmpName", idx: 1 },
  { id: "LoginTime", label: "LOGINTIME", idx: 2 },
  { id: "LogoutTime", label: "LOGOUTTIME", idx: 3 },
];

const MaxAttendanceCard = ({
  title,
  subtitle,
  number,
  arr,
  arr2,
  classNames,
  activeBtn,
}) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const { user } = useUser();
  const { ClientId, CompCode } = user;

  const handleOpen = (e) => {
    e.stopPropagation(); // Prevent flip on button click
    setOpen(true);
    fetchData();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let res;
      res = await fetch(
        `${API_URL}/facility/get-login-logout-times/1/${CompCode}/${ClientId}/UNTAPS009554/0/${getTodayDate()}/${getTodayDate()}`
      ).then((res) => res.json());
      setData(res.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const handleFlip = () => {
    setFlipped(!flipped);
  };

  const renderTable = () => {
    return <EnhancedTable columns={columns} data={data} />;
  };

  return (
    <Box
      className={`flip-card ${flipped ? "flipped" : ""}`}
      onClick={handleFlip}
    >
      <Box className="flip-card-inner">
        <Box className="flip-card-front">
          <Card
            sx={{
              minWidth: 200,
              width: 220,
              height: 141, // Ensure height is fixed to prevent overflow
              boxShadow: 3,
              borderRadius: 2,
              overflow: "hidden", // Prevent content overflow
            }}
            className={classNames}
          >
            <CardContent>
              <Typography
                sx={
                  title.length < 15
                    ? {
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "25px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        fontFamily: "Poppins, sans-serif",
                      }
                    : {
                        color: "#fff",
                        fontSize: "12px",
                        fontWeight: "500",
                        padding: "0",
                        lineHeight: "25px",
                        margin: "0px 0px 0px 0vw",
                        letterSpacing: "2px",
                        textTransform: "uppercase",
                        fontFamily: "Poppins, sans-serif",
                      }
                }
                color="#fff"
                gutterBottom
              >
                {title}
              </Typography>
              <Typography variant="h3" component="div">
                {number}
              </Typography>
              <Stack direction="row" spacing={1}>
                <Typography
                  sx={{
                    color: "#67737B",
                    margin: "0px 0px 0px 0px",
                    fontWeight: "700",
                    fontSize: "14px",
                    fontFamily: "Share Tech Mono",
                  }}
                  color="text.secondary"
                >
                  {subtitle}
                </Typography>
                {activeBtn && (
                  <Button
                    size="small"
                    variant="outlined"
                    sx={{
                      height: "20px",
                      color: "#fff",
                      fontSize: "10px",
                      marginLeft: "auto", // Align button to the right
                    }}
                    onClick={handleOpen}
                  >
                    view
                  </Button>
                )}
              </Stack>
            </CardContent>
          </Card>
        </Box>
        <Box className="flip-card-back">
          <Card
            sx={{
              minWidth: 200,
              width: 220,
              height: 250, // Ensure height is fixed to prevent overflow
              boxShadow: 3,
              borderRadius: 2,
              bgcolor: "background.paper",
              color: "text.primary",
              overflow: "hidden", // Prevent content overflow
            }}
            className={classNames}
          >
            <CardContent>
              {arr.map(
                (ele, idx) =>
                  idx <= 3 && (
                    <Typography
                      sx={
                        title.length < 15
                          ? {
                              color: "#fff",
                              fontSize: "10px",
                              fontWeight: "500",
                              padding: "0",
                              lineHeight: "25px",
                              margin: "0px 0px 0px 0vw",
                              letterSpacing: "1px",
                              textTransform: "uppercase",
                              fontFamily: "Poppins, sans-serif",
                            }
                          : {
                              color: "#fff",
                              fontSize: "10px",
                              fontWeight: "500",
                              padding: "0",
                              lineHeight: "25px",
                              margin: "0px 0px 0px 0vw",
                              letterSpacing: "1px",
                              textTransform: "uppercase",
                              fontFamily: "Poppins, sans-serif",
                            }
                      }
                      color="#fff"
                      gutterBottom
                      key={idx}
                    >
                      {ele.Designation}
                      <span style={{ fontSize: "12px" }}>
                        : {ele.Count}/
                        {arr2.find(
                          (ele2) => ele2.Designation === ele.Designation
                        )?.Count || "0"}
                      </span>
                    </Typography>
                  )
              )}
            </CardContent>
          </Card>
        </Box>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            width: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : data ? (
            renderTable()
          ) : (
            "No data available"
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default MaxAttendanceCard;
